import React from "react";
import classes from "./Feature.module.css";

function Feature(props) {
  return (
    <li className={classes.FeatureItem}>
      <img src={props.src} alt="" className={classes.FeatureItemImg} />
      <p className={classes.FeatureItemText}>{props.text}</p>
    </li>
  );
}

export default Feature;
